import axios from "axios";
import React, { useEffect, useState } from "react";
import * as constantUrls from "../../../constants/urls";
import { DatePicker } from "jalali-react-datepicker";
import leftArrowBlackImage from "../../../assets/images/left_arrow_black.png";
import enterBlackImage from "../../../assets/images/enter_key_black.png";
import { useCookies } from "react-cookie";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

const AddSpecialDiscount = (props) => {
    const [allActiveCategoriesInformation, setAllActiveCategoriesInformation] =
        useState([]);
    const [discountId, setDiscountId] = useState(props.id);
    const [filtersDisplayClass, setFiltersDisplayClass] = useState("d-none");
    const [startDateInputState, setStartDateInputState] = useState(new Date());
    const [endDateInputState, setEndDateInputState] = useState(new Date());
    const [discountStartDateInputState, setDiscountStartDateInputState] =
        useState(new Date()); //
    const [discountFinishDateInputState, setDiscountFinishDateInputState] =
        useState(new Date()); //
    const [
        discountExpirationDateInputState,
        setDiscountExpirationDateInputState,
    ] = useState(new Date()); //
    const [coursesInformation, setCoursesInformation] = useState([]);
    const [categoryId, setCategoryId] = useState(-1);
    const [focusedCourseIndex, setFocusedCourseIndex] = useState(-1);
    const [coursesDiscountInformation, setCoursesDiscountInformation] =
        useState([]);
    const [expirationDateIsChecked, setExpirationDateIsChecked] =
        useState(false);
    const [startAndFinishDateIsChecked, setStartAndFinishDateIsChecked] =
        useState(false);
    const [discountStatus, setDiscountStatus] = useState(0); //
    const [discountTitle, setDiscountTitle] = useState(""); //
    const [discountDescription, setDiscountDescription] = useState(""); //
    const [selectedCoursesInformation, setSelectedCoursesInformation] =
        useState([]);
    const [selectedSectionId, setSelectedSectionId] = useState(0);
    const [focusedCourseIndexForEdit, setFocusedCourseIndexForEdit] =
        useState(-1);
    const [
        manipulatedCourseEditInformation,
        setManipulatedCourseEditInformation,
    ] = useState([]);
    const [priceBoundaryCheckboxChecked, setPriceBoundaryCheckboxChecked] =
        useState(false);

    const [sellCountChecked, setSellCountChecked] =
        useState(false);

    const [sumOrderChecked, setSumOrderChecked] =
        useState(false);

    const [sellCountMin, setSellCountMin] = useState("");
    const [sellCountMax, setSellCountMax] = useState("");

    const [sumOrderMin, setSumOrderMin] = useState("");
    const [sumOrderMax, setSumOrderMax] = useState("");

    const [priceBoundaryMinPrice, setPriceBoundaryMinPrice] = useState("");
    const [priceBoundaryMaxPrice, setPriceBoundaryMaxPrice] = useState("");
    const [sleepCheckboxChecked, setSleepCheckboxChecked] = useState(false);
    const [stockCheckboxChecked, setStockCheckboxChecked] = useState(false);
    const [factorDateChecked, setFactorDateChecked] = useState(false);
    const [discountInformation, setDiscountInformation] = useState(null);

    const [discountPack, setDiscountPacks] = useState([]);
    const [packs, setPacks] = useState([]);

    const [minStock, setMinStock] = useState("");
    const [maxStock, setMaxStock] = useState("");
    const [minSleep, setMinSleep] = useState("");
    const [maxSleep, setMaxSleep] = useState("");

    const [cookies, setCookie, removeCookie] = useCookies();

    let indexs = -1;

    useEffect(() => {
        indexs = -1;
    }, []);

    useEffect(() => {
        axios
            .post(
                constantUrls.apiUrl + "/api/class-active-categories",
                {},
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                let response = r.data;
                if (response.status === "done") {
                    setAllActiveCategoriesInformation(response.categories);
                } else {
                    alert("here is the error");
                    alert(response.umessage);
                }
            })
            .catch((e) => {
                console.error(e);
                alert("خطا در برقراری ارتباط");
            });
    }, []);

    useEffect(() => {
        if (props.stage === "secondEdit") {
            axios
                .post(
                    constantUrls.apiUrl +
                    "/api/discount/multi-class-discount-courses",
                    {
                        discountId: discountId,
                    },
                    {
                        headers: {
                            Authorization:
                                "Bearer " + cookies.user_server_token,
                        },
                    },
                )
                .then((r) => {
                    console.log(r);

                    let response = r.data;
                    if (response.status === "done") {
                        if (response.found === true) {
                            setSelectedCoursesInformation(response.courses);
                        }
                    } else if (response.status === "failed") {
                        console.log("no");

                        alert(response.umessage);
                    }
                })
                .catch((e) => {
                    console.error(e);
                    alert("خطا در برقراری ارتباط");
                });
        }
    }, []);

    useEffect(() => {
        if (props.stage === "secondEdit") {
            axios
                .post(
                    constantUrls.apiUrl +
                    "/api/discount/multi-class-discount-information",
                    {
                        discountId: discountId,
                    },
                    {
                        headers: {
                            Authorization:
                                "Bearer " + cookies.user_server_token,
                        },
                    },
                )
                .then((r) => {
                    let response = r.data;
                    if (response.status === "done") {
                        setDiscountInformation(response.information);
                        setDiscountTitle(response.information.title);
                        setDiscountDescription(
                            response.information.description,
                        );
                        setDiscountStatus(response.information.status);
                        if (response.information.start_date != null) {
                            setDiscountStartDateInputState(
                                new Date(
                                    response.information.start_date * 1000,
                                ),
                            );
                        }
                        if (response.information.finish_date != null) {
                            setDiscountFinishDateInputState(
                                new Date(
                                    response.information.finish_date * 1000,
                                ),
                            );
                        }
                        if (response.information.expiration_date != null) {
                            setDiscountExpirationDateInputState(
                                new Date(
                                    response.information.expiration_date * 1000,
                                ),
                            );
                            setExpirationDateIsChecked(true);
                        }
                        if (
                            response.information.start_date != null &&
                            response.information.finish_date != null
                        ) {
                            setStartAndFinishDateIsChecked(true);
                        }
                    } else if (response.status === "failed") {
                        console.warn(response.message);
                        alert(response.umessage);
                    }
                })
                .catch((e) => {
                    console.error(e);
                    alert("خطا در برقراری ارتباط");
                });
        }
    }, []);

    const getSectionDisplayClass = (i) => {
        if (i === selectedSectionId) {
            return "activeTopMenuButton";
        } else {
            return "deactiveTopMenuButton";
        }
    };

    const getNewCourses = (obj) => {
        let c = categoryId;
        if (obj.categoryId !== undefined) {
            c = obj.categoryId;
        }

        let minP = "";
        let maxP = "";
        let minSell = "";
        let maxSell = "";
        let minCount = "";
        let maxCount = "";
        let sd = "";
        let ed = "";

        if (priceBoundaryCheckboxChecked) {
            minP = priceBoundaryMinPrice;
            maxP = priceBoundaryMaxPrice;
        }
        if (sumOrderChecked) {
            minSell = sumOrderMin;
            maxSell = sumOrderMax;
        }
        if (sellCountChecked) {
            minCount = sellCountMin;
            maxCount = sellCountMax;
        }

        axios
            .post(
                constantUrls.apiUrl +
                "/api/discount/no-paginated-filter-category-classes",
                {
                    discountId: discountId,
                    categoryId: c,
                    
                    minPrice: minP,
                    maxPrice: maxP,

                    minCount: minCount,
                    maxCount: maxCount,

                    minSell: minSell,
                    maxSell: maxSell,
                },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                let response = r.data;
                if (response.status === "done") {
                    if (response.found === true) {
                        setPacks(response.courses);
                    } else if (response.found === false) {
                        setCoursesInformation([]);
                    }

                    let newCoursesDiscountInformation = [];
                    response.courses.map((course, index) => {
                        newCoursesDiscountInformation.push({
                            id: course.id,
                            percent: 0,
                            price: 0,
                        });
                    });
                    setDiscountPacks(newCoursesDiscountInformation);
                } else if (response.status === "failed") {
                    alert("مشکلی پیش آمده");
                }
            })
            .catch((e) => {
                console.error(e);
                alert("خطا در برقراری ارتباط");
            });
        setFocusedCourseIndex(-1);
    };

    const categorySelectorChanged = (event) => {
        if (event.target.value !== categoryId) {
            setCategoryId(event.target.value);
            // getNewCourses({categoryId: event.target.value});
        }
    };

    const searchButtonClicked = () => {
        getNewCourses({});
    };

    const coursePercentInputChanged = (event) => {
        if (event.target.value != "" && event.target.value !== 0) {
            let newCourseDiscountInformation = [];
            discountPack.map((course, index) => {
                if (focusedCourseIndex == index) {
                    course.percent = parseInt(event.target.value);
                    newCourseDiscountInformation.push(course);
                } else {
                    newCourseDiscountInformation.push(course);
                }
            });
            setDiscountPacks(newCourseDiscountInformation);
        } else {
            let newCourseDiscountInformation = [];
            discountPack.map((course, index) => {
                if (focusedCourseIndex == index) {
                    course.percent = 0;
                    newCourseDiscountInformation.push(course);
                } else {
                    newCourseDiscountInformation.push(course);
                }
            });
            setDiscountPacks(newCourseDiscountInformation);
        }
    };

    const coursePriceInputChanged = (event) => {
        if (event.target.value != "" && event.target.value !== 0) {
            let newCourseDiscountInformation = [];
            discountPack.map((course, index) => {
                if (focusedCourseIndex == index) {
                    course.price = parseInt(event.target.value);
                    newCourseDiscountInformation.push(course);
                } else {
                    newCourseDiscountInformation.push(course);
                }
            });
            setDiscountPacks(newCourseDiscountInformation);
        } else {
            let newCourseDiscountInformation = [];
            discountPack.map((course, index) => {
                if (focusedCourseIndex == index) {
                    course.price = 0;
                    newCourseDiscountInformation.push(course);
                } else {
                    newCourseDiscountInformation.push(course);
                }
            });
            setDiscountPacks(newCourseDiscountInformation);
        }
    };

    const focusOnProduct = (e) => {
        setFocusedCourseIndex(e.target.attributes.inde.value);
    };

    const submitDiscountCourses = () => {
        let newCourseDiscountInformation = [];
        discountPack.map((course, key) => {
            if (course.price !== 0 || course.percent !== 0) {
                if (course.price !== 0 && course.percent !== 0) {
                    course.price = 0;
                }
                newCourseDiscountInformation.push(course);
            }
        });
        axios
            .post(
                constantUrls.apiUrl +
                "/api/discount/add-courses-to-multi-course-discount",
                {
                    discountId: discountId,
                    courses: newCourseDiscountInformation,
                },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                let response = r.data;
                if (response.status === "done") {
                    updateSelectedCourseInformation("add", {
                        courses: newCourseDiscountInformation,
                    });
                    setSelectedSectionId(2);
                    setStockCheckboxChecked(false);
                    setSleepCheckboxChecked(false);
                    setPriceBoundaryCheckboxChecked(false);
                    setFactorDateChecked(false);
                } else if (response.status === "failed") {
                    alert(response.umessage);
                }
            })
            .catch((e) => {
                console.error(e);
                alert("خطا در برقراری ارتباط");
            });
    };

    const startAndFinishDateCheckboxChanged = (event) => {
        setStartAndFinishDateIsChecked(event.target.checked);
    };

    const expirationDateCheckboxChanged = (event) => {
        setExpirationDateIsChecked(event.target.checked);
    };

    const discountActiveCheckboxClicked = () => {
        setDiscountStatus(1);
    };

    const discountDeactiveCheckboxClicked = () => {
        setDiscountStatus(0);
    };

    const discountTitleInputChanged = (event) => {
        setDiscountTitle(event.target.value);
    };

    const discountDescriptionInputChanged = (event) => {
        setDiscountDescription(event.target.value);
    };

    const submitDiscountInformationClicked = () => {
        if (
            discountTitle == undefined ||
            discountDescription == undefined ||
            discountTitle?.trim().length == 0 ||
            discountDescription?.trim().length == 0
        ) {
            alert("لطفا عنوان و توضیحات تخفیف را به درستی وارد کنید");
            return;
        }
        let startDate = 0;
        let finishDate = 0;
        let expirationDate = 0;
        let status = discountStatus;
        if (startAndFinishDateIsChecked) {
            startDate = Math.floor(discountStartDateInputState / 1000);
            finishDate = Math.floor(discountFinishDateInputState / 1000);
        }
        if (expirationDateIsChecked) {
            expirationDate = Math.floor(
                discountExpirationDateInputState / 1000,
            );
        }
        axios
            .post(
                constantUrls.apiUrl +
                "/api/discount/edit-multi-course-discount-general-information",
                {
                    discountId: discountId,
                    title: discountTitle?.trim(),
                    description: discountDescription?.trim(),
                    startDate: startDate,
                    finishDate: finishDate,
                    expirationDate: expirationDate,
                    status: status,
                },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                let response = r.data;
                if (response.status === "done") {
                    alert("ویرایش با موفقیت انجام شد");
                } else if (response.status === "failed") {
                    console.warn(response.message);
                    alert(response.umessage);
                }
            })
            .catch((e) => {
                console.error(e);
                alert("خطا در برقراری ارتباط");
            });
    };

    const generalSettingsLayout = (
        <div
            className={["row", "p-2", "mt-3", "rtl"].join(" ")}
            style={{ borderRadius: "3px", border: "1px solid #DEDEDE" }}
        >
            <div
                className={[
                    "col-6",
                    "d-flex",
                    "flex-row",
                    "rtl",
                    "text-right",
                    "align-items-center",
                ].join(" ")}
            >
                <img
                    src={leftArrowBlackImage}
                    style={{ width: "20px", height: "20px" }}
                />
                <h6
                    className={["rtl", "font14", "mb-0", "mx-2"].join(" ")}
                    style={{}}
                >
                    عنوان :
                </h6>
                <input
                    type="text"
                    defaultValue={discountTitle}
                    onChange={discountTitleInputChanged}
                    className={["rtl", "text-right", "font14"].join(" ")}
                    style={{ flex: "1" }}
                />
            </div>
            <div
                className={[
                    "col-6",
                    "d-flex",
                    "flex-row",
                    "rtl",
                    "text-right",
                    "align-items-center",
                ].join(" ")}
            >
                <img
                    src={leftArrowBlackImage}
                    style={{ width: "20px", height: "20px" }}
                />
                <h6
                    className={["rtl", "font14", "mb-0", "mx-2"].join(" ")}
                    style={{}}
                >
                    توضیحات :
                </h6>
                <input
                    type="text"
                    defaultValue={discountDescription}
                    onChange={discountDescriptionInputChanged}
                    className={["rtl", "text-right", "font14"].join(" ")}
                    style={{ flex: "1" }}
                />
            </div>
            <div
                className={[
                    "col-6",
                    "d-flex",
                    "flex-row",
                    "align-items-center",
                    "mt-3",
                    "rtl",
                ].join(" ")}
            >
                <img
                    src={leftArrowBlackImage}
                    style={{ width: "20px", height: "20px" }}
                />
                <input
                    type="checkbox"
                    checked={startAndFinishDateIsChecked}
                    onChange={startAndFinishDateCheckboxChanged}
                    className={["mr-2", "pointer"].join(" ")}
                />
                <h6 className={["mb-0", "mx-2", "mb-0", "font14"].join(" ")}>
                    تاریخ شروع و پایان
                </h6>
                {startAndFinishDateIsChecked ? (
                    <React.Fragment>
                        <h6
                            className={["mb-0", "mx-2", "mb-0", "font14"].join(
                                " ",
                            )}
                        >
                            از :
                        </h6>
                        <DatePicker
                            className={["font14"].join(" ")}
                            style={{ direction: "rtl", flex: "1" }}
                            value={discountStartDateInputState}
                            onClickSubmitButton={(value) => {
                                setDiscountStartDateInputState(value.value._d);
                            }}
                        />
                        <h6
                            className={["mb-0", "mx-2", "mb-0", "font14"].join(
                                " ",
                            )}
                        >
                            تا :
                        </h6>
                        <DatePicker
                            className={["font14"].join(" ")}
                            style={{ direction: "rtl", flex: "1" }}
                            value={discountFinishDateInputState}
                            onClickSubmitButton={(value) => {
                                setDiscountFinishDateInputState(value.value._d);
                            }}
                        />
                    </React.Fragment>
                ) : null}
            </div>
            <div
                className={[
                    "col-6",
                    "d-flex",
                    "flex-row",
                    "align-items-center",
                    "mt-3",
                    "rtl",
                ].join(" ")}
            >
                <img
                    src={leftArrowBlackImage}
                    style={{ width: "20px", height: "20px" }}
                />
                <input
                    type="checkbox"
                    checked={expirationDateIsChecked}
                    onChange={expirationDateCheckboxChanged}
                    className={["mr-2", "pointer"].join(" ")}
                />
                <h6 className={["mb-0", "mx-2", "mb-0", "font14"].join(" ")}>
                    تاریخ انقضا :
                </h6>
                {expirationDateIsChecked ? (
                    <DatePicker
                        className={["font14"].join(" ")}
                        style={{ direction: "rtl", flex: "1" }}
                        value={
                            discountInformation != null
                                ? discountInformation.expiration_date * 1000
                                : discountExpirationDateInputState
                        }
                        onClickSubmitButton={(value) => {
                            setDiscountExpirationDateInputState(value.value._d);
                        }}
                    />
                ) : null}
            </div>
            <div
                className={[
                    "col-6",
                    "d-flex",
                    "flex-row",
                    "align-items-center",
                    "mt-3",
                    "rtl",
                ].join(" ")}
            >
                <img
                    src={leftArrowBlackImage}
                    style={{ width: "20px", height: "20px" }}
                />
                <h6 className={["mb-0", "mx-2", "mb-0", "font14"].join(" ")}>
                    وضعیت :{" "}
                </h6>
                <input
                    type="checkbox"
                    checked={discountStatus === 1 ? true : false}
                    className={["pointer"].join(" ")}
                    onChange={discountActiveCheckboxClicked}
                />
                <h6 className={["mb-0", "mx-2", "mb-0", "font14"].join(" ")}>
                    فعال
                </h6>
                <input
                    type="checkbox"
                    checked={discountStatus === 1 ? false : true}
                    className={["pointer"].join(" ")}
                    onChange={discountDeactiveCheckboxClicked}
                />
                <h6 className={["mb-0", "mx-2", "mx-0", "font14"].join(" ")}>
                    غیر فعال
                </h6>
            </div>
            <div
                className={[
                    "col-12",
                    "d-flex",
                    "flex-row",
                    "justify-content-center",
                ].join(" ")}
            >
                <button
                    onClick={submitDiscountInformationClicked}
                    className={["px-4", "py-1", "pointer"].join(" ")}
                    style={{
                        color: "#FFFFFF",
                        background: "#008000",
                        borderStyle: "none",
                        outlineStyle: "none",
                        borderRadius: "2px",
                    }}
                >
                    ذخیره اطلاعات
                </button>
            </div>
        </div>
    );

    const getSectionLayout = () => {
        if (selectedSectionId === 0) {
            return generalSettingsLayout;
        } else if (selectedSectionId == 1) {
            return addProductLayout;
        } else if (selectedSectionId === 2) {
            return editCourseLayout;
        }
    };

    const priceBoundaryCheckboxChanged = (event) => {
        setPriceBoundaryCheckboxChecked(event.target.checked);
    };

    const minPriceChanged = (event) => {
        setPriceBoundaryMinPrice(event.target.value);
    };

    const maxPriceChanged = (event) => {
        setPriceBoundaryMaxPrice(event.target.value);
    };

    const totalPercentChanged = (event) => {
        if (event.target.value !== "" && event.target.value !== 0) {
            let newCourseDiscountInformation = [];
            discountPack.map((course, index) => {
                course.percent = parseInt(event.target.value);
                newCourseDiscountInformation.push(course);
            });
            setDiscountPacks(newCourseDiscountInformation);
        } else {
            let newCourseDiscountInformation = [];
            discountPack.map((course, index) => {
                course.percent = 0;
                newCourseDiscountInformation.push(course);
            });
            setDiscountPacks(newCourseDiscountInformation);
        }
    };

    const totalPriceChanged = (event) => {
        if (event.target.value !== "" && event.target.value !== 0) {
            let newCourseDiscountInformation = [];
            discountPack.map((course, index) => {
                course.price = parseInt(event.target.value);
                newCourseDiscountInformation.push(course);
            });
            setDiscountPacks(newCourseDiscountInformation);
        } else {
            let newCourseDiscountInformation = [];
            discountPack.map((course, index) => {
                course.price = 0;
                newCourseDiscountInformation.push(course);
            });
            setDiscountPacks(newCourseDiscountInformation);
        }
    };

    const addProductLayout = (
        <React.Fragment>
            <div className={["row", "mt-3", "rtl"].join(" ")}>
                <div
                    className={[
                        "col-12",
                        "px-2",
                        "d-flex",
                        "flex-row",
                        "align-items-center",
                    ].join(" ")}
                >
                    <h6 className={["text-center", "mb-0", "font14"].join(" ")}>
                        دسته‌بندی موردنظر را انتخاب کنید
                    </h6>
                    <select
                        onChange={categorySelectorChanged}
                        className={["mr-3", "font14", "d-none"].join(" ")}
                        style={{ flex: "1", maxHeight: "200px" }}
                    >
                        <option value={0}>انتخاب کنید</option>
                        {allActiveCategoriesInformation.map(
                            (category, index) => {
                                return (
                                    <option key={index} value={category.id}>
                                        {category.name}
                                    </option>
                                );
                            },
                        )}
                    </select>
                    <Autocomplete
                        className={[
                            "col-10",
                            "text-right",
                            "justify-content-right",
                            "m-0",
                            "p-0",
                        ].join(" ")}
                        style={{
                            direction: "rtl",
                            fontFamily: "IranSansWebFaNum",
                        }}
                        id="controllable-states-demo"
                        noOptionsText="..."
                        onChange={(event, newValue) => {
                            if (newValue !== null) {
                                categorySelectorChanged({
                                    target: { value: newValue.id },
                                });
                            }
                        }}
                        options={allActiveCategoriesInformation}
                        getOptionLabel={(allActiveCategoriesInformation) =>
                            allActiveCategoriesInformation.name
                        }
                        renderInput={(params) => (
                            <TextField
                                className={["text-right"].join(" ")}
                                {...params}
                                variant="outlined"
                                style={{
                                    fontFamily: "IranSansWebFaNum",
                                    direction: "rtl",
                                }}
                            />
                        )}
                    />
                </div>
                <div
                    className={[
                        "col-12",
                        "d-flex",
                        "flex-row",
                        "align-items-center",
                        "text-right",
                        "rtl",
                        "mt-2",
                    ].join(" ")}
                >
                    <button
                        onClick={() => {
                            setFiltersDisplayClass("d-flex");
                        }}
                        className={[
                            filtersDisplayClass === "d-none" ? "" : "d-none",
                            "px-3",
                            "py-1",
                            "pointer",
                            "mt-0",
                        ].join(" ")}
                        style={{
                            fontSize: "14px",
                            background: "#F2F2F2",
                            borderRadius: "3px",
                            border: "none",
                            outlineStyle: "none",
                        }}
                    >
                        جستجوی پیشرفته
                    </button>
                    <div
                        className={[
                            filtersDisplayClass,
                            "flex-row",
                            "rtl",
                            "text-right",
                            "align-items-center",
                        ].join(" ")}
                        style={{ flex: "1" }}
                    >
                        <input
                            type="checkbox"
                            onChange={priceBoundaryCheckboxChanged}
                            className={["mr-3", "mt-0", "pointer"].join(" ")}
                        />
                        <h6
                            className={[
                                "mb-0",
                                "text-right",
                                "rtl",
                                "mr-1",
                                "pt-0",
                                "pl-1",
                                "font14",
                            ].join(" ")}
                        >
                            قیمت کالا
                        </h6>
                        <input
                            type="number"
                            onChange={minPriceChanged}
                            className={[
                                "ltr",
                                "text-left",
                                "font14",
                                "mx-1",
                                priceBoundaryCheckboxChecked ? "" : "d-none",
                            ].join(" ")}
                            placeholder="حداقل قیمت"
                            style={{ maxWidth: "140px" }}
                        />
                        <input
                            type="number"
                            onChange={maxPriceChanged}
                            className={[
                                "ltr",
                                "text-left",
                                "font14",
                                "mx-1",
                                priceBoundaryCheckboxChecked ? "" : "d-none",
                            ].join(" ")}
                            placeholder="حداکثر قیمت"
                            style={{ maxWidth: "140px" }}
                        />





                        <input
                            type="checkbox"
                            onChange={(e) => { setSellCountChecked(e.target.checked) }}
                            className={["mr-3", "mt-0", "pointer"].join(" ")}
                        />
                        <h6
                            className={[
                                "mb-0",
                                "text-right",
                                "rtl",
                                "mr-1",
                                "pt-0",
                                "pl-1",
                                "font14",
                            ].join(" ")}
                        >
                            تعداد فروش
                        </h6>
                        <input
                            type="number"
                            onChange={(e) => { setSellCountMin(e.target.value) }}
                            className={[
                                "ltr",
                                "text-left",
                                "font14",
                                "mx-1",
                                sellCountChecked ? "" : "d-none",
                            ].join(" ")}
                            placeholder="حداقل تعداد فروش"
                            style={{ maxWidth: "140px" }}
                        />
                        <input
                            type="number"
                            onChange={(e) => { setSellCountMax(e.target.value) }}
                            className={[
                                "ltr",
                                "text-left",
                                "font14",
                                "mx-1",
                                sellCountChecked ? "" : "d-none",
                            ].join(" ")}
                            placeholder="حداکثر تعداد فروش"
                            style={{ maxWidth: "140px" }}
                        />




                        <input
                            type="checkbox"
                            onChange={(e) => { setSumOrderChecked(e.target.checked) }}
                            className={["mr-3", "mt-0", "pointer"].join(" ")}
                        />
                        <h6
                            className={[
                                "mb-0",
                                "text-right",
                                "rtl",
                                "mr-1",
                                "pt-0",
                                "pl-1",
                                "font14",
                            ].join(" ")}
                        >
                            مبلغ فروش
                        </h6>
                        <input
                            type="number"
                            onChange={(e) => { setSumOrderMin(e.target.value) }}
                            className={[
                                "ltr",
                                "text-left",
                                "font14",
                                "mx-1",
                                sumOrderChecked ? "" : "d-none",
                            ].join(" ")}
                            placeholder="حداقل مبلغ فروش"
                            style={{ maxWidth: "140px" }}
                        />
                        <input
                            type="number"
                            onChange={(e) => { setSumOrderMax(e.target.value) }}
                            className={[
                                "ltr",
                                "text-left",
                                "font14",
                                "mx-1",
                                sumOrderChecked ? "" : "d-none",
                            ].join(" ")}
                            placeholder="حداکثر مبلغ فروش"
                            style={{ maxWidth: "140px" }}
                        />




                        <button
                            onClick={searchButtonClicked}
                            className={[
                                "px-3",
                                "py-1",
                                "mt-0",
                                "mr-3",
                                "mb-0",
                                "pointer",
                                "font14",
                            ].join(" ")}
                            style={{
                                borderRadius: "3px",
                                background: "green",
                                color: "white",
                                border: "none",
                                outlineStyle: "none",
                            }}
                        >
                            جستجو
                        </button>
                    </div>
                </div>
                <div
                    className={[
                        "col-12",
                        "d-flex",
                        "flex-row",
                        "align-items-center",
                        "text-right",
                        "rtl",
                        "mt-2",
                    ].join(" ")}
                >
                    <div
                        className={[
                            "d-flex",
                            "flex-row",
                            "rtl",
                            "text-right",
                            "align-items-center",
                        ].join(" ")}
                        style={{ flex: "1" }}
                    >
                        <h6 className={["mb-0", "font14"].join(" ")}>
                            درصد کلی :{" "}
                        </h6>
                        <input
                            type="number"
                            onChange={totalPercentChanged}
                            className={["font14", "mr-1", "text-center"].join(
                                " ",
                            )}
                            style={{ maxWidth: "100px" }}
                            placeholder="%"
                        />
                        <h6 className={["mb-0", "mr-2", "font14"].join(" ")}>
                            قیمت کلی :{" "}
                        </h6>
                        <input
                            type="number"
                            onChange={totalPriceChanged}
                            className={["font14", "mr-1", "text-center"].join(
                                " ",
                            )}
                            style={{ maxWidth: "100px" }}
                            placeholder="$"
                        />
                    </div>
                </div>
            </div>
            <div
                className={[
                    "row",
                    "p-2",
                    "mt-2",
                    "align-items-center",
                    "text-right",
                    "rtl",
                ].join(" ")}
                style={{ background: "#F2F2F2", borderRadius: "2px" }}
            >
                <h6
                    className={[
                        "col-4",
                        "text-rigt",
                        "mb-0",
                        "font14",
                        "colorMain",
                    ].join(" ")}
                >
                    نام محصول
                </h6>
                <h6
                    className={[
                        "col-1",
                        "text-center",
                        "mb-0",
                        "font14",
                        "colorMain",
                    ].join(" ")}
                >
                    قیمت محصول
                </h6>
                <h6
                    className={[
                        "col-1",
                        "text-center",
                        "mb-0",
                        "font14",
                        "colorMain",
                    ].join(" ")}
                >
                    درصد تخفیف
                </h6>
                <h6
                    className={[
                        "col-1",
                        "text-center",
                        "mb-0",
                        "font14",
                        "colorMain",
                    ].join(" ")}
                >
                    مقدار تخفیف
                </h6>

                <h6
                    className={[
                        "col-1",
                        "text-center",
                        "mb-0",
                        "font14",
                        "colorMain",
                    ].join(" ")}
                >
                    تعداد کل فروش
                </h6>


                <h6
                    className={[
                        "col-1",
                        "text-center",
                        "mb-0",
                        "font14",
                        "colorMain",
                    ].join(" ")}
                >
                    مقدار کل فروش
                </h6>
            </div>
            {console.log("packs", packs)}
            {packs.map((course, key) => {
                indexs += 1;
                return (
                    <div
                        key={key}
                        className={[
                            "row",
                            "p-2",
                            "mt-2",
                            "align-items-center",
                            "text-right",
                            "rtl",
                        ].join(" ")}
                        style={{
                            background: "#F2F2F2",
                            borderRadius: "2px",
                        }}
                    >
                        <h6
                            in={indexs}
                            className={[
                                "col-4",
                                "text-center",
                                "mb-0",
                                "font14",
                            ].join(" ")}
                        >
                            {course.courseName}
                        </h6>
                        <h6
                            className={[
                                "col-1",
                                "text-center",
                                "mb-0",
                                "font14",
                            ].join(" ")}
                        >
                            {course.coursePrice}
                        </h6>
                        <input
                            inde={indexs}
                            type="number"
                            defaultValue=""
                            value={
                                discountPack[indexs] != undefined
                                    ? discountPack[indexs].percent
                                    : 0
                            }
                            onFocus={(e) => {
                                focusOnProduct(e);
                            }}
                            placeholder="درصد"
                            onChange={coursePercentInputChanged}
                            className={["col-1", "text-center", "font14"].join(
                                " ",
                            )}
                            style={{
                                borderStyle: "none",
                                outlineStyle: "none",
                                borderRadius: "2px",
                            }}
                        />
                        <input
                            inde={indexs}
                            type="number"
                            defaultValue=""
                            value={
                                discountPack[indexs] != undefined
                                    ? discountPack[indexs].price
                                    : 0
                            }
                            onFocus={(e) => {
                                focusOnProduct(e);
                            }}
                            onChange={coursePriceInputChanged}
                            placeholder="قیمت"
                            className={["col-1", "text-center", "font14"].join(
                                " ",
                            )}
                            style={{
                                borderStyle: "none",
                                outlineStyle: "none",
                                borderRadius: "2px",
                            }}
                        />
                        <h6
                            className={[
                                "col-1",
                                "text-center",
                                "mb-0",
                                "font14",
                            ].join(" ")}
                        >
                            {course.counts}
                        </h6>
                        <h6
                            className={[
                                "col-1",
                                "text-center",
                                "mb-0",
                                "font14",
                            ].join(" ")}
                        >
                            {course.sumPrice}
                        </h6>
                    </div>
                );
            })}

            {discountPack.length !== 0 ? (
                <div className={["row"].join(" ")}>
                    <div
                        className={[
                            "col-12",
                            "d-flex",
                            "flex-row",
                            "justify-content-center",
                            "mb-2",
                        ].join(" ")}
                    >
                        <button
                            onClick={submitDiscountCourses}
                            className={[
                                "px-4",
                                "py-2",
                                "font14",
                                "mt-2",
                                "pointer",
                            ].join(" ")}
                            style={{
                                background: "#008000",
                                color: "white",
                                borderStyle: "none",
                                outlineStyle: "none",
                                borderRadius: "2px",
                            }}
                        >
                            افزودن کلاس ها به تخفیف
                        </button>
                    </div>
                </div>
            ) : null}
        </React.Fragment>
    );

    const courseEditButtonClicked = (key) => {
        console.log("manipulatedCourseEditInformation mohammasd", [
            manipulatedCourseEditInformation,
            key,
        ]);
        let price =
            manipulatedCourseEditInformation[key].price !== ""
                ? manipulatedCourseEditInformation[key].price
                : 0;
        let percent =
            manipulatedCourseEditInformation[key].percent !== ""
                ? manipulatedCourseEditInformation[key].percent
                : 0;
        let courseId = selectedCoursesInformation[key].courseId;
        axios
            .post(
                constantUrls.apiUrl +
                "/api/discount/edit-multi-class-discount-course-information",
                {
                    discountId: discountId,
                    courseId: courseId,
                    price: price,
                    percent: percent,
                },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                let response = r.data;
                if (response.status === "done") {
                    updateSelectedCourseInformation("update", {
                        courseId: courseId,
                        price: price,
                        percent: percent,
                    });
                    alert("ویرایش با موفقیت انجام شد");
                } else if (response.status === "failed") {
                    alert(response.umessage);
                }
            })
            .catch((e) => {
                console.error(e);
                alert("خطا در برقراری ارتباط");
            });
    };

    const updateSelectedCourseInformation = (method, input) => {
        if (method === "update") {
            let newCourseInformation = [];
            selectedCoursesInformation.map((info, index) => {
                if (info.courseId === input.courseId) {
                    info.discountPrice = input.price;
                    info.discountPercent = input.percent;
                    newCourseInformation.push(info);
                } else {
                    newCourseInformation.push(info);
                }
            });
            setSelectedCoursesInformation(newCourseInformation);
        } else if (method === "remove") {
            let newCourseInformation = [];
            for (let i = 0; i < selectedCoursesInformation.length; i++) {
                if (selectedCoursesInformation[i].courseId != input.courseId) {
                    newCourseInformation.push(selectedCoursesInformation[i]);
                }
            }
            /*
            selectedCoursesInformation.map((info, index) => {
                if(info.courseId != input.courseId){
                    newCourseInformation.push(info);
                }
            });
            */
            setSelectedCoursesInformation(newCourseInformation);
            console.warn(newCourseInformation);
        } else if (method === "add") {
            let newCourseInformation = [];
            let b = [];
            let a = selectedCoursesInformation;
            // newCourseInformation.map((i, c) => {
            //    a.push(i);
            //});
            input.courses.map((p, c) => {
                packs.map((infos, index) => {
                    if (p.id === infos.id) {
                        a.push({
                            courseId: infos.id,
                            courseName: infos.courseName,
                            courseUrl: infos.courseUrl,
                            discountPrice: p.price,
                            discountPercent: p.percent,
                        });
                        console.log("add");
                    }
                });
            });

            setSelectedCoursesInformation(a);
            console.warn("warning is here", a);
            let newCourseDiscountInformation = [];
            packs.map((infos, index) => {
                let allowPack = [];

                let found = false;
                input.courses.map((p, c) => {
                    if (infos.id == p.id) {
                        found = true;
                    }
                });
                if (!found) {
                    newCourseDiscountInformation.push({
                        id: infos.id,
                        price: 0,
                        percent: 0,
                    });
                    allowPack.push(infos);
                }
                if (allowPack != null && allowPack != []) {
                    infos.packs = allowPack;
                    console.log("allowPack", allowPack);
                    b.push(infos);
                }
            });
            console.log(
                "newProductDiscountInformation2",
                newCourseDiscountInformation,
            );

            setPacks(b);
            setDiscountPacks(newCourseDiscountInformation);
            fillManipulatedCoursesEditInformation();
        }
    };

    const courseRemoveButtonClicked = (key) => {
        let courseId = selectedCoursesInformation[key].courseId;
        axios
            .post(
                constantUrls.apiUrl +
                "/api/discount/remove-course-from-multi-class-discount",
                {
                    discountId: discountId,
                    courseId: courseId,
                },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                let response = r.data;
                if (response.status === "done") {
                    updateSelectedCourseInformation("remove", {
                        courseId: courseId,
                    });
                } else if (response.status === "failed") {
                    console.warn(response.message);
                    alert(response.umessage);
                }
            })
            .catch((e) => {
                console.error(e);
                alert("خطا در برقراری ارتباط");
            });
    };

    const coursePercentInputChangedForEdit = (event) => {
        let newEditInformation =
            manipulatedCourseEditInformation[focusedCourseIndexForEdit];
        let newManipulatedCourseEditInformation = [];
        newEditInformation.percent = 0;
        if (event.target.value.trim() !== "") {
            newEditInformation.percent = parseInt(event.target.value.trim());
        }
        manipulatedCourseEditInformation.map((info, index) => {
            if (index !== setFocusedCourseIndexForEdit) {
                newManipulatedCourseEditInformation.push(info);
            } else {
                newManipulatedCourseEditInformation.push(newEditInformation);
            }
        });

        setManipulatedCourseEditInformation(
            newManipulatedCourseEditInformation,
        );
    };

    const coursePriceInputChangedForEdit = (event) => {
        let newEditInformation =
            manipulatedCourseEditInformation[focusedCourseIndexForEdit];
        let newManipulatedCourseEditInformation = [];
        newEditInformation.price = 0;
        if (event.target.value.trim() !== "") {
            newEditInformation.price = parseInt(event.target.value.trim());
        }
        manipulatedCourseEditInformation.map((info, index) => {
            if (index !== setFocusedCourseIndexForEdit) {
                newManipulatedCourseEditInformation.push(info);
            } else {
                newManipulatedCourseEditInformation.push(newEditInformation);
            }
        });
        setManipulatedCourseEditInformation(
            newManipulatedCourseEditInformation,
        );
    };

    const fillManipulatedCoursesEditInformation = () => {
        let newEditInformation = [];
        selectedCoursesInformation.map((info, index) => {
            newEditInformation.push({
                price: info.discountPrice,
                percent: info.discountPercent,
            });
        });
        setManipulatedCourseEditInformation(newEditInformation);
    };

    const sortSelectedCoursesInformation = (column, method) => {
        let info = selectedCoursesInformation;
        if (column == "percent" && method == "desc") {
            console.log(info[0]);
            let i = 0,
                j = 0;
            console.warn("started");
            for (i = selectedCoursesInformation.length - 1; i >= 0; i--) {
                for (j = 0; j < i; j++) {
                    if (info[j].discountPercent < info[j + 1].discountPercent) {
                        let a = info[j];
                        info[j] = info[j + 1];
                        info[j + 1] = a;
                    }
                }
            }
            setSelectedCoursesInformation(info);
            console.warn("finished");
            setSelectedSectionId(3);
            fillManipulatedCoursesEditInformation();
            setSelectedSectionId(2);
        }
    };

    const editCourseLayout = (
        <React.Fragment>
            <div
                className={["row", "rtl", "p-2", "mt-2", "mx-1"].join(" ")}
                style={{
                    background: "#F2F2F2",
                    borderRadius: "2px",
                    color: "#00BAC6",
                }}
            >
                <h6
                    className={["col-1", "font14", "text-right", "mb-0"].join(
                        " ",
                    )}
                >
                    ردیف
                </h6>
                <h6
                    className={["col-3", "font14", "text-right", "mb-0"].join(
                        " ",
                    )}
                >
                    نام محصول
                </h6>
                <h6
                    className={["col-1", "font14", "text-center", "mb-0"].join(
                        " ",
                    )}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        sortSelectedCoursesInformation("percent", "desc");
                    }}
                >
                    درصد تخفیف
                </h6>
                <h6
                    className={["col-1", "font14", "text-center", "mb-0"].join(
                        " ",
                    )}
                >
                    مبلغ تخفیف
                </h6>
                <h6
                    className={["col-1", "font14", "text-center", "mb-0"].join(
                        " ",
                    )}
                >
                    ویرایش
                </h6>
                <h6
                    className={["col-1", "font14", "text-center", "mb-0"].join(
                        " ",
                    )}
                >
                    حذف
                </h6>
            </div>
            {console.log(
                "manipulatedCourseEditInformation",
                manipulatedCourseEditInformation,
            )}
            {selectedCoursesInformation.map((courseInformation, index) => {
                return (
                    <div
                        className={[
                            "row",
                            "rtl",
                            "p-2",
                            "mt-2",
                            "mx-1",
                            "align-items-center",
                        ].join(" ")}
                        style={{ background: "#F2F2F2", borderRadius: "2px" }}
                    >
                        <h6
                            className={[
                                "col-1",
                                "font14",
                                "text-right",
                                "mb-0",
                            ].join(" ")}
                        >
                            {index + 1}
                        </h6>
                        <h6
                            className={[
                                "col-3",
                                "font14",
                                "text-right",
                                "mb-0",
                            ].join(" ")}
                        >
                            <a
                                href={
                                    constantUrls.siteUrl + "/academy/courses/" +
                                    courseInformation.courseUrl
                                }
                                target="_blank"
                            >
                                {courseInformation.courseName}
                            </a>
                        </h6>
                        <input
                            type="number"
                            defaultValue=""
                            placeholder={courseInformation.discountPercent}
                            onFocus={() => {
                                setFocusedCourseIndexForEdit(index);
                            }}
                            onChange={coursePercentInputChangedForEdit}
                            className={["col-1", "font-14", "text-center"].join(
                                " ",
                            )}
                            style={{
                                borderStyle: "none",
                                borderRadius: "2px",
                                outlineStyle: "none",
                            }}
                        />
                        <input
                            type="number"
                            defaultValue=""
                            placeholder={courseInformation.discountPrice}
                            onFocus={() => {
                                setFocusedCourseIndexForEdit(index);
                            }}
                            onChange={coursePriceInputChangedForEdit}
                            className={["col-1", "font-14", "text-center"].join(
                                " ",
                            )}
                            style={{
                                borderStyle: "none",
                                borderRadius: "2px",
                                outlineStyle: "none",
                            }}
                        />
                        <button
                            onClick={() => {
                                courseEditButtonClicked(index);
                            }}
                            className={["col-1", "pointer"].join(" ")}
                            style={{
                                background: "#FFC107",
                                color: "black",
                                borderStyle: "none",
                                outlineStyle: "none",
                                borderRadius: "2px",
                            }}
                        >
                            ویرایش
                        </button>
                        <button
                            onClick={() => {
                                courseRemoveButtonClicked(index);
                            }}
                            className={["col-1", "pointer"].join(" ")}
                            style={{
                                background: "#DC3545",
                                color: "white",
                                borderStyle: "none",
                                outlineStyle: "none",
                                borderRadius: "2px",
                            }}
                        >
                            حذف
                        </button>
                    </div>
                );
            })}
        </React.Fragment>
    );

    return (
        <div className={["container-fluid"].join(" ")}>
            <div className={["row"].join(" ")}>
                <div
                    className={[
                        "col-12",
                        "d-flex",
                        "flex-row",
                        "align-items-center",
                        "rtl",
                        "justify-content-right",
                    ].join(" ")}
                >
                    <img
                        src={enterBlackImage}
                        style={{ width: "20px", height: "20px" }}
                    />
                    <button
                        className={[
                            "px-2",
                            "py-1",
                            "mr-2",
                            getSectionDisplayClass(0),
                        ].join(" ")}
                        onClick={() => {
                            setSelectedSectionId(0);
                        }}
                    >
                        ویرایش اطلاعات
                    </button>
                    <button
                        className={[
                            "px-2",
                            "py-1",
                            "mr-2",
                            getSectionDisplayClass(1),
                        ].join(" ")}
                        onClick={() => {
                            setSelectedSectionId(1);
                            setPriceBoundaryMinPrice("");
                            setPriceBoundaryMaxPrice("");
                            setPriceBoundaryCheckboxChecked(false);
                        }}
                    >
                        افزودن کلاس ها
                    </button>
                    <button
                        className={[
                            "px-2",
                            "py-1",
                            "mr-2",
                            getSectionDisplayClass(2),
                        ].join(" ")}
                        onClick={() => {
                            setSelectedSectionId(2);
                            fillManipulatedCoursesEditInformation();
                        }}
                    >
                        ویرایش محصولات
                    </button>
                </div>
            </div>
            {getSectionLayout()}
            <div
                className={["row", "px-2"].join(" ")}
                style={{ position: "sticky", bottom: "0.5rem" }}
            >
                {typeof props.close === "function" ? (
                    <button
                        className={[
                            "btn",
                            "btn-danger",
                            "col-12",
                            "mt-2",
                            "mx-0",
                        ].join(" ")}
                        onClick={props.close}
                    >
                        خروج
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default AddSpecialDiscount;
